<template>
    <div id="workRoot">

        <InfoHeader :information="work.information"/>

        <!-- Probably no need for a title with the theme that you want to go with for the site -->
        <!--        <div id="title">-->
        <!--            <div v-if="work.media.length" class="workContent">-->
        <!--                <p>Content</p>-->
        <!--            </div>-->
        <!--        </div>-->

        <div id="content">
            <component v-for="(media, index) in work.media"
                       :key="index"
                       :is="media.cardType"
                       :source="media.link"
                       :secondSource="media.secondLink"
                       :caption="media.caption"
                       :margin ="media.margin"
                       :backgroundCaption="media.backgroundCaption"
            >
            </component>
        </div>

        <Related :related="work.related"/>

    </div>
</template>

<script>
	import InfoHeader from "../components/InfoHeader.vue";
	import ImageCard from "../components/ImageCard.vue";
	import VideoCard from "../components/cards/VideoCard.vue";
	import DualVideoCard from "../components/DualVideoCard.vue";
	import MediumVideoCard from "../components/MediumVideoCard.vue";
	import MediumVideoCardRight from "../components/MediumVideoCardRight.vue";
	import Related from "../components/Related.vue";
	import CardParallaxLarge from "../components/CardParallaxLarge.vue";

	export default {
		components: {
			InfoHeader,
			ImageCard,
			VideoCard,
			DualVideoCard,
			MediumVideoCard,
			MediumVideoCardRight,
			CardParallaxLarge,
			Related
		},
		props: {
			isInfoClicked: {
				type: Boolean,
				default: false
			},
			isCloseClicked: {
				type: Boolean,
				default: false
			},
			id: {
				type: String,
				required: true
			}
		},
		data() {
			return {
				cardType: Image
			};
		},
		created() {
			document.title = this.work.name + " - OT";
		},
		computed: {
			work() {
				return this.$store.state.works[this.id];
			}
		}
	};
</script>

<style lang="scss" src="../styles/work.scss" scoped></style>
